'use strict';

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('.reset-button').on('click', function () {
        $('body').removeClass('modal-open');
    });
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
    hideOverlay();
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    const $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
    if (!$suggestions.length) return;

    if (isMobileSearch(scope)) {
        // Mobile: height and behavior handled relative to viewport
        setSuggestionsOffset(scope);
        bindViewportRecompute(scope);
    }

    // Unfortunately, we have to bind this dynamically, as the live scroll event was not
    // properly detecting dynamic suggestions element's scroll event
    $suggestions.scroll(function () {
        handleMoreContentBelowIcon(this);
    });

    handleMoreContentBelowIcon($suggestions[0]);
}

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    let $nav = $(scope).closest('.navigation');

    if ($nav.length) {
        return $nav.find('.suggestions-wrapper');
    }

    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Returns the current visible viewport height in CSS pixels.
 *
 * @returns {number} Height of the visible viewport in pixels.
 */
function getViewportHeight() {
    return (window.visualViewport && window.visualViewport.height) || window.innerHeight;
}

/**
 * Computes the vertical space available below the given input element within the
 * current viewport.
 *
 * @param {HTMLElement} inputEl - The input element (e.g., the search field) used as the reference.
 * @returns {number} Available height in pixels below the element within the viewport.
 */
function computeAvailableHeightBelowInput(inputEl) {
    const elPosition = inputEl.getBoundingClientRect();
    const bottomOfInput = elPosition.bottom; // distance du haut du viewport -> bas du champ
    const vh = getViewportHeight();
    const available = Math.max(0, vh - bottomOfInput);
    return Math.floor(available);
}

/**
 * Positions suggestions panel just under the `.search-mobile` container by
 * setting a CSS variable `--suggestions-top` in pixels. Also updates the
 * available height below the input for vertical scroll within the panel.
 *
 * @param {HTMLElement} scope - Usually the search input element
 */
function setSuggestionsOffset(scope) {
    const $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
    if (!$suggestions.length) return;

    if (isMobileSearch(scope)) {
        const available = computeAvailableHeightBelowInput(scope);
        $suggestions.css({
            maxHeight: available + 'px',
            height: 'auto',
            overflowY: 'auto'
        });
    }
}

/**
 * Recompute on viewport changes (resize, orientation, URL bar show/hide).
 * @param {HTMLElement} scope - html element
 */
function bindViewportRecompute(scope) {
    const recompute = () => setSuggestionsOffset(scope);

    $(window).off('resize._sugg').on('resize._sugg', recompute);
    $(window).off('orientationchange._sugg').on('orientationchange._sugg', recompute);

    if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', recompute);
        window.visualViewport.addEventListener('resize', recompute, { passive: true });
    }
}

/**
 * Ensures a full-screen overlay exists in the DOM, creating it if missing.
 *
 * @returns {void}
 */
function ensureOverlay() {
    if (!$('.search-overlay').length) {
        $('body').append('<div class="search-overlay" aria-hidden="true"></div>');
    }
}

/**
 * Shows the overlay and prevents background page scrolling.
 *
 * @returns {void}
 */
function showOverlay() {
    ensureOverlay();
    $('.search-overlay').addClass('active');
    $('body').addClass('search-overlay-open');
}

/**
 * Hides the overlay and restores background page scrolling.
 *
 * @returns {void}
 */
function hideOverlay() {
    $('.search-overlay').removeClass('active');
    $('body').removeClass('search-overlay-open');
    $('.search-overlay').remove();
}

module.exports = {
    clearModals: clearModals,
    applyModals: applyModals,
    tearDownSuggestions: tearDownSuggestions,
    toggleSuggestionsIcon: toggleSuggestionsIcon,
    positionSuggestions: positionSuggestions,
    getSuggestionsWrapper: getSuggestionsWrapper,
    isMobileSearch: isMobileSearch,
    setSuggestionsOffset: setSuggestionsOffset,
    bindViewportRecompute: bindViewportRecompute,
    showOverlay: showOverlay,
    hideOverlay: hideOverlay
};
